import { createContext, ReactNode, useContext } from "react";

export interface TemplateDataContextType {
	templateData: any;
}

const defaultContextValues = {
	templateData: undefined,
} as TemplateDataContextType;

interface TemplateDataProps {
	children: ReactNode;
	templateData?: any;
}

export const TemplateDataContext = createContext<TemplateDataContextType>(defaultContextValues);
export const useTemplateDataContext = () => useContext(TemplateDataContext);
export function TemplateDataProvider(props: TemplateDataProps) {
	const { children, templateData } = props;
	return <TemplateDataContext.Provider value={{ templateData }}>{children}</TemplateDataContext.Provider>;
}
